import { render, staticRenderFns } from "./beta-signup-form.vue?vue&type=template&id=34b84186&scoped=true&"
import script from "./beta-signup-form.vue?vue&type=script&lang=tsx&"
export * from "./beta-signup-form.vue?vue&type=script&lang=tsx&"
import style0 from "./beta-signup-form.vue?vue&type=style&index=0&id=34b84186&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b84186",
  null
  
)

export default component.exports